import { useState } from 'react';
import css from 'styled-jsx/css';
import {ASSET_PREFIX, colors} from "utils/constants";
import React from "react";
import { signUpForNewsletterAndDiscount } from 'utils/api/auth';
import RoundedButton from "../RoundedButton";
import {
  fetchUtmParamsJoinedWithFbDataFromLocalStorage,
  identifyUser,
  trackMailingListSignup,
} from 'utils/analytics/analytics';
import HeroImageBackgroundContainer from "components/HeroImageBackgroundContainer";

const StayInTheLoopSection = () => {
  const [email, setEmail] = useState('');
  const [successful, setSuccessful] = useState(false);

  return (
    <HeroImageBackgroundContainer style={{ color: 'white' }}>
      <div className='paddedMaxWidthContainer' style={{ paddingTop: '2em' }}>
        <h2 style={{ color: '#59FFDE', textShadow: `0px 0px 10px blue` }}>
          STAY IN THE <span className='outlineText'>LOOP</span>
        </h2>

        <div style={{ width: '280px', height: '2px', backgroundColor: '#59FFDE', boxShadow: `0px 0px 10px blue`, marginTop: '10px', marginBottom: '10px' }} />

        <input
          placeholder='Email Address'
          type='email'
          autoComplete='email'
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />

        <p style={{ margin: '2em 1em', maxWidth: '300px', fontWeight: 600 }}>
          By clicking Submit, you agree to receive exclusive news and offers - NO spam (we promise).
        </p>

        { !successful ?
          <RoundedButton style={{ minWidth: '180px', marginBottom: '2em' }} onClick={async () => {
            const utmParams = fetchUtmParamsJoinedWithFbDataFromLocalStorage();
            const res = await signUpForNewsletterAndDiscount('FOOTER', email, '', utmParams);
            if (res.successful === true) {
              setSuccessful(true);
              identifyUser({ emailAddress: email });
              trackMailingListSignup(email);
            }
          }}>
            SUBMIT
          </RoundedButton>
        :
          <p style={{ margin: '2em 1em', maxWidth: '300px', fontWeight: 'bold', fontSize: '1.3em' }}>
            Great, you're signed up!
          </p>
        }

      </div>

      <style jsx>{styles}</style>
    </HeroImageBackgroundContainer>
  );
};

const styles = css`
:global(.footer) {
  margin-top: 0!important;
}

.outlineText {
  -webkit-text-fill-color: transparent;
  -webkit-text-stroke-width: 1.5px;
  -webkit-text-stroke-color: #59FFDE;
  text-shadow: 0 0 5px #00A1FF;
}

input {
  margin-top: 20px;
  background-color: rgba(0,0,0,0.35);
  color: white;
  font-size: 17px;
  font-weight: 600;
  padding: 0.5em 1em;
  min-width: 250px;
  border-radius: 3px;
  border: 2px solid #50E3C2;
  box-shadow: 0px 0px 40px rgba(20,20,255,0.5);
}
`;

export default StayInTheLoopSection;
